"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _themeProvider = require("@mmc/theme-provider");
var _commonCta = require("@mmc/common-cta");
var _calculatorOptionsBtn = _interopRequireDefault(require("./calculator-options-btn.css"));
var CalculatorOptionsBtn = function CalculatorOptionsBtn(_ref) {
  var label = _ref.label,
    onOpen = _ref.onOpen;
  var theme = (0, _themeProvider.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorOptionsBtn["default"].calculatorOptionsBtn
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    clickEvent: onOpen,
    data: {
      label: label,
      icon: 'Filter',
      priority: 'lowIcon'
    }
  }));
};
var _default = CalculatorOptionsBtn;
exports["default"] = _default;